import { HAS_WINDOW } from '@eventbrite/feature-detection';

const hasSessionStorage = () => HAS_WINDOW && window.sessionStorage;

export const setStorageItem = (key: string, value: any) => {
    if (hasSessionStorage()) {
        sessionStorage.setItem(key, JSON.stringify(value));
    }
};

export const getStorageItem = (key: string) => {
    if (!hasSessionStorage()) {
        return;
    }

    let data = sessionStorage.getItem(key);
    if (data) {
        try {
            data = JSON.parse(data);
        } catch (err) {
            data = null;
        }
    }

    return data;
};
